










































import { defineComponent, onMounted, computed } from "@vue/composition-api";
import { useVuex } from "@/hooks/use-vuex";
import { useRouter } from "@/hooks/use-router";
import { usePrices } from "@/hooks/use-prices";
import { Network } from "@/models/network";
import { usePin } from "@/hooks/use-pin";
export default defineComponent({
  setup(_, ctx) {
    const {
      prices,
      tokenPrices,
      baseCurrency,
      updatePrices,
      lastFetched
    } = usePrices();
    const { store } = useVuex();
    const router = useRouter();

    const settings = computed(() => store.state.Settings);
    const login = computed(() => store.state.Login.disclaimerConsent);
    const forging = computed(
      () => store.state.Wallet.forging && store.state.Wallet.forgingString
    );

    const accept = async () => {
      store.commit.Login.acceptDisclaimer();

      if (store.state.Wallet.wallets.length <= 0) {
        if (!store.state.Login.pinCreated) {
          await usePin().getPin(true);
        }
        const network = store.state.Wallet.networks.find(
          w => w.name === "main.ton.dev"
        ) as Network;
        store.commit.Wallet.setNetwork(network);
        store.dispatch.Wallet.forgeWallet({
          name: "My Wallet"
        });
      } else {
        router.push("/portfolio");
      }
    };

    const update = (force?: boolean) => {
      updatePrices(force).then(() =>
        store.dispatch.Wallet.updateWallets(force)
      );
    };

    onMounted(() => {
      update();
    });

    return {
      open,
      update,
      baseCurrency,
      lastFetched,
      settings,
      accept,
      forging
    };
  }
});
